import { useRef } from "react";
import { CircularProgress } from "@mui/material";
import { UploadOutlined } from "@mui/icons-material";
import { colors } from "../../../../theme/theme";
import {
  AvatarBox,
  AvatarImage,
  AvatarOverlay,
  FieldLabel,
  ImageUploadWrapper,
} from "../practitionerForm.styles";
import { LABEL_YOUR_PICTURE } from "../practitionerForm.constants";

const AvatarSection = ({
  avatar,
  avatarLoading,
  onFileSelect,
  onImageLoad,
  onImageError,
}) => {
  const inputRef = useRef(null);

  const handleBrowse = () => {
    inputRef.current?.click();
  };

  return (
    <ImageUploadWrapper>
      <FieldLabel>{LABEL_YOUR_PICTURE}</FieldLabel>
      <AvatarBox onClick={handleBrowse}>
        <input
          ref={inputRef}
          type="file"
          style={{ display: "none" }}
          accept="image/*"
          onChange={onFileSelect}
        />
        {avatar ? (
          <>
            <AvatarImage
              src={avatar}
              alt="profile"
              style={{
                opacity: avatarLoading ? 0 : 1,
              }}
              onLoad={onImageLoad}
              onError={onImageError}
            />
            {avatarLoading && (
              <AvatarOverlay>
                <CircularProgress size={32} sx={{ color: colors.primary }} />
              </AvatarOverlay>
            )}
          </>
        ) : (
          <UploadOutlined sx={{ color: colors.primary }} />
        )}
      </AvatarBox>
    </ImageUploadWrapper>
  );
};

export default AvatarSection;
